import { Box } from '@mui/material'
import React from 'react'
import blogo from '../Assests/Autopartslogo.png';

function Home() {
    return (
        <>
            {/* <Box sx={{ width: '100vw', height: '100vh', background: '#02847A', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> */}
            <Box sx={{ width: '100vw', height: '100vh', background: '#000000', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                    src={blogo}
                    alt='mainLogo'
                    draggable={false}
                    height='100%'
                />
            </Box>



        </>
    )
}

export default Home